import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { InsuranceComponentWrapper } from '@app/pages/quote/insurance/insurance/insurance-wrapper.component';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance-desktop.component.html',
  styleUrls: ['./insurance-desktop.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InsuranceDesktopComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InsuranceDesktopComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InsuranceDesktopComponent extends InsuranceComponentWrapper {

  constructor(
    route: ActivatedRoute,
    menuService: MenusServices,
    notification: NotificationService
  ) {
    super(route, menuService, notification);
  }
}
